module.exports = __webpack_public_path__ + "img/login-bg-10.2d4eeffd.jpg";